
import React, { useState, useEffect } from 'react';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-slate-950/80 backdrop-blur-md border-b border-slate-800 py-4' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <a href="#hero" className="text-xl font-bold tracking-tighter hover:text-emerald-400 transition-colors">
          GBENLANDIA<span className="text-emerald-500">.</span>
        </a>
        
        <div className="hidden md:flex gap-8 text-sm font-medium uppercase tracking-widest text-slate-400 items-center">
          <a href="#about" className="hover:text-white transition-colors">Strategy</a>
          <a href="#work" className="hover:text-white transition-colors">Systems</a>
          <a href="#stack" className="hover:text-white transition-colors">Stack</a>
          <button 
            data-cal-namespace="gtm-audit-revenue-bottleneck-identification"
            data-cal-link="gbenlandia/gtm-audit-revenue-bottleneck-identification"
            data-cal-config='{"layout":"month_view","theme":"dark"}'
            className="text-emerald-400 hover:text-emerald-300 transition-colors bg-transparent border-none cursor-pointer font-medium uppercase tracking-widest text-sm"
          >
            Hire Me
          </button>
        </div>

        <div className="md:hidden">
           {/* Mobile menu could go here, but keeping it minimalist for single scroller */}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
